import React from "react";
import MtiButton from "../Buttons/MtiButton";
import "../../WarningView.css";

type Props = {
  message: string;
  subMessage: string;
  onClickOk: () => void;
};

export default function WarningModalView({
  message,
  subMessage,
  onClickOk,
}: Props) {
  return (
    <div className="app-warning-wait-container">
      <span className="warning-title-wait">Warning</span>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gridArea: "animation",
          marginBottom: 40,
          marginTop: 41,
        }}
      >
        <svg
          width="71"
          height="71"
          viewBox="0 0 71 71"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.4998 70.0833C54.5997 70.0833 70.0832 54.5998 70.0832 35.5C70.0832 16.4001 54.5997 0.916626 35.4998 0.916626C16.4 0.916626 0.916504 16.4001 0.916504 35.5C0.916504 54.5998 16.4 70.0833 35.4998 70.0833ZM28.5832 7.83329L32.0415 42.4166H38.9582L42.4165 7.83329H28.5832ZM35.4998 63.1666C39.3198 63.1666 42.4165 60.0699 42.4165 56.25C42.4165 52.43 39.3198 49.3333 35.4998 49.3333C31.6799 49.3333 28.5832 52.43 28.5832 56.25C28.5832 60.0699 31.6799 63.1666 35.4998 63.1666Z"
            fill="#F7A246"
          />
        </svg>
      </div>
      <span className="warning-message-wait centered">{message}</span>
      <span className="warning-sub-message-wait centered">{subMessage}</span>
    </div>
  );
}
